export default 'Accessibilité (RGAA / WCAG 2.2 AA) | Solution Éco France';
